import { createSelector } from '@reduxjs/toolkit';
import { selectHouseAddress } from './selectHouseAddress';

export const selectPageTitle = createSelector(selectHouseAddress, address => {
  const addressStr = address
    .reduce((result, { type, fullName }) => (['street', 'house'].includes(type) ? [...result, fullName] : result), [])
    .join(', ');

  return `Дом по адресу ${addressStr}`;
});
